<button type="button" pButton pRipple icon="fa fa-file-excel-o" pTooltip="Download data in Excel format" tooltipPosition="bottom"
        (click)="onClickExportToExcel()" class="icon-action2"></button>
<!--<button type="button" pButton pRipple icon="fa fa-file-pdf-o" pTooltip="PDF" tooltipPosition="bottom"-->
<!--        (click)="utilityService.exportPdf(dataTable.value, dataTable.columns, filename)"></button>-->
